import { render, staticRenderFns } from "./UploadComponent.vue?vue&type=template&id=960ebb4c"
import script from "./UploadComponent.vue?vue&type=script&lang=js"
export * from "./UploadComponent.vue?vue&type=script&lang=js"
import style0 from "./UploadComponent.vue?vue&type=style&index=0&id=960ebb4c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports